export default __webpack_public_path__ + "static/media/yaara-kalmanovich.5f1b6ec1.png";